// Register Stimulus controllers. With esbuild there is no importmap
// auto-loading, so register each controller explicitly here.
import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import SortableTreeController from "./sortable_tree_controller"
application.register("sortable-tree", SortableTreeController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import CellEditorController from "./cell_editor_controller"
application.register("cell-editor", CellEditorController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import FontSizeController from "./font_size_controller"
application.register("font-size", FontSizeController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)
